var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.21875 35.5V1.375H13.1719C17.3125 1.375 20.4531 2.17188 22.5938 3.76562C24.7344 5.34375 25.8047 7.66406 25.8047 10.7266C25.8047 12.3984 25.375 13.875 24.5156 15.1562C23.6562 16.4219 22.4609 17.3516 20.9297 17.9453C22.6797 18.3828 24.0547 19.2656 25.0547 20.5938C26.0703 21.9219 26.5781 23.5469 26.5781 25.4688C26.5781 28.75 25.5312 31.2344 23.4375 32.9219C21.3438 34.6094 18.3594 35.4688 14.4844 35.5H1.21875ZM8.25 20.6406V29.8516H14.2734C15.9297 29.8516 17.2188 29.4609 18.1406 28.6797C19.0781 27.8828 19.5469 26.7891 19.5469 25.3984C19.5469 22.2734 17.9297 20.6875 14.6953 20.6406H8.25ZM8.25 15.6719H13.4531C17 15.6094 18.7734 14.1953 18.7734 11.4297C18.7734 9.88281 18.3203 8.77344 17.4141 8.10156C16.5234 7.41406 15.1094 7.07031 13.1719 7.07031H8.25V15.6719Z",
    fill: "url(#paint0_linear_6_9)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_9",
    x1: 13.8984,
    y1: 1.375,
    x2: 13.8984,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9AE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 35,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/B.5b5aaac42dc108883ea845d8b0b045f5.svg";
export { ForwardRef as ReactComponent };